import formatDate from '@/services/general/formatIsoDate';
import calculArrondi from '@/services/calcul/calculArrondi';

export default function preparationDesLettrages(dataTable, idMouvementPrincipal) {
  const allLettrages = {
    lettrages: [],
  };
  dataTable.forEach((mouvementAvecLettrage) => {
    const unitLettrage = {
      id: mouvementAvecLettrage.idLettrage,
      dateLettrage: formatDate(new Date()),
      montant: parseFloat(calculArrondi(mouvementAvecLettrage.inputLetterage)),
      mouvementClient1Id: idMouvementPrincipal,
      mouvementClient2Id: mouvementAvecLettrage.idEcheance,
    };
    allLettrages.lettrages.push(unitLettrage);
  });
  return allLettrages;
}
